import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { postFormData, getData } from 'utils/service';
  // declaring the types for our state
  export type PerformanceState = {
    subjects: any;
    performanceData: any
    pending: boolean;
  };
  
  const initialState: PerformanceState = {
    subjects: [],
    performanceData: [],
    pending: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getActiveSubjects = createAsyncThunk('api/all_active_subjects', async () => {
    let response: any = await getData('all_active_subjects', {});
    if (response.success === "true") {
      return response
    }
    return {};
  });
  export const getPerformanceData = createAsyncThunk('api/subject_performance', async (data:any) => {
    // const {subject_id} = data;
    let response: any = await postFormData('subject_performance', data);
    if (response.success === "true") {
        return response;
    }
    return [];
});
  export const performanceSlice = createSlice({
    name: 'performance',
    initialState,
    reducers: {
    },

    extraReducers: builder => {
      builder
        .addCase(getActiveSubjects.pending, state => {
          state.pending = true;
        })
        .addCase(getActiveSubjects.fulfilled, (state, { payload }) => {
          state.pending = false;
          state.subjects = (payload.data) ? payload.data : [];
        }) 
        .addCase(getPerformanceData.pending, state => {
            state.pending = true;
        })
        .addCase(getPerformanceData.fulfilled, (state, { payload }) => {
            state.pending = false;
            state.performanceData = (payload.data) ? payload.data : [];
        });;
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
   
  } = performanceSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectPerformance = (state: RootState) => state.performance;
  
  // exporting the reducer here, as we need to add this to the store
  export default performanceSlice.reducer;